exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".faq-container[data-v-28aa17c9]{margin:0 auto}.faq-question[data-v-28aa17c9]{padding:0;transition:all .3s}.faq-description[data-v-28aa17c9]{cursor:pointer;border-top:1px solid #d1d3d4;position:relative;transition:all .3s}.faq-description span[data-v-28aa17c9]:last-child{transition:all .3s;position:absolute;font-size:2em}.faq-question.open[data-v-28aa17c9]{background:#f7f7f7}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-rewriter.js?id=data-v-28aa17c9&scoped=true!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/AccordionMenu.vue
// module id = 41
// module chunks = 0